
import { useState } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { addSocialProfile } from '@/lib/supabase/social';
import { Card } from '@/components/ui/card';
import { SocialPlatform } from '../profiles/types';
import AddProfileHeader from './AddProfileHeader';
import AddProfileContent from './AddProfileContent';
import { AddProfileProps } from './types';

const AddProfile = ({
  handlePageChange
}: AddProfileProps) => {
  const {
    toast
  } = useToast();
  
  const handleSelectPlatform = (platform: SocialPlatform) => {
    // Si YouTube est sélectionné, naviguer vers le formulaire spécifique YouTube
    if (platform.platform === 'youtube') {
      handlePageChange('add-youtube-profile');
      return;
    }
    
    // Pour les autres plateformes, continuer avec le comportement existant
    localStorage.setItem('selectedPlatform', JSON.stringify(platform));
    handlePageChange('add-profile-form');
  };
  
  return (
    <Card className="bg-white dark:bg-gray-800 rounded-lg shadow-card overflow-hidden max-w-6xl mx-auto">
      <AddProfileHeader onBack={() => handlePageChange('profiles')} />
      <AddProfileContent onSelectPlatform={handleSelectPlatform} />
    </Card>
  );
};

export default AddProfile;
